<template>
    <div class="sl-app">
        <div class="sl-search-wrap">
            <div class="sl-search-box" :class="{'show-results': state.locations.length && !state.showSearchForm}">
                <SearchForm v-if="state.showSearchForm" @search="handleSearchBtnClick" />

                <ListHeader />

                <div id="location-wrapper" class="sl-list-wrapper">
                    <List v-if="!state.showSearchForm" :locations="state.locations" />
                </div>
            </div>
        </div>

        <div class="sl-map-wrapper">
            <button v-if="!state.calculatingPostalCode"
                    class="white-btn-search"
                    :class="{
                        'sl-visible': state.showMapOnMobile
                    }"
                    type="button"
                    @click="handleSearchArea">
                Search this Area
            </button>

            <div id="azure-map" />
        </div>

        <div v-if="state.showFeaturedOnMobile" class="sl-featured-location">
            <Location v-if="state.showMapOnMobile && state.featuredLocation" :location="state.featuredLocation" :featured="true" />
        </div>
    </div>
</template>

<script>

import SearchForm from './SearchForm';
import List from './List';
import ListHeader from './ListHeader';
import state from '../utils/state';
import AzureMaps from '../utils/azureMaps';
import axios from 'axios';
import sampleData from '../utils/sampleData';
import sampleMfeEvents from '../utils/sampleMfeEvents';
import Location from './Location';

function sortByDistanceAway ( a, b ) {
    if ( a.distanceAway < b.distanceAway ) {
        return -1;
    }

    if ( a.distanceAway > b.distanceAway ) {
        return 1;
    }

    return 0;
}

export default {
    components: {
        List,
        SearchForm,
        ListHeader,
        Location
    },

    computed: {
        allowedToSearch () {
            if (this.state.loading || (!this.state.searchType || this.state.searchType === '') || !this.state.searchPostalCode || !this.state.searchDistance) {
                return false;
            }

            return true;
        },
    },

    mounted () {      
        this.importLocatorConfig();  

        const urlParams = new URLSearchParams(window.location.search);
        const urlSearchType = urlParams.get('type');

        if (urlSearchType) {

            if (urlSearchType === 'retailers') {
                this.state.searchType = 'retailer';
            }

            if (urlSearchType === 'events') {
                this.state.searchType = 'events';
            }

            if (urlSearchType === 'locations') {
                this.state.searchType = 'locations';
            }
        }

        const mapLat = 37.09024; 
        const mapLong = -95.712891; 

        AzureMaps.init(this.state, mapLong, mapLat);

        this.$nextTick(() => {
            AzureMaps.addEventListeners(this.handleClickOnPin);

            // this.getBrowserCoordinates();
        });
    },

    methods: {
        handleClickOnPin (locationId) {
            const results = this.state.locations.filter(location => {
                location.open = false;

                return location.id == locationId;
            });

            if (results.length) {
                results[0].open = true;
                this.highlightSingleLocation(results[0]);
            }

            this.$nextTick(() => {
                const locationElements = document.getElementsByClassName('sl-location');

                for (const elem of locationElements) { 
                    if (elem.dataset.id == locationId) {
                        const offset = elem.offsetTop;
                    
                        document.getElementById('location-wrapper').scrollTo({
                            top     : offset - 90, 
                            behavior: 'smooth'
                        });
                    }
                }
            });

            this.state.showFeaturedOnMobile = true;

        },

        highlightSingleLocation (location) {
            this.state.featuredLocation = location;
        },
        
        importLocatorConfig () {
            for (const prop in window.LocatorConfig) {
                this.state[prop] = window.LocatorConfig[prop];
            }
        },

        handleSearchBtnClick () {
            if (!this.allowedToSearch) return;

            this.state.loading = true;

            this.state.searchPostalCode = (`${this.state.searchPostalCode}`).toUpperCase();

            this.clearStoreList();

            this.search();
        },

        clearStoreList () {
            for (let i = this.state.locations.length; i >= 0; i--) {
                this.state.locations.splice(i, 1);
            }
        },

        async search () {
            this.state.showFeaturedOnMobile = false;

            const geoData = await AzureMaps.getGeoData(this.state.countryCode, this.state.searchPostalCode);

            if (!geoData) {
                return;
            }

            this.state.locations = [];
            
            AzureMaps.setCameraPositionByLongLat(geoData.position.lon, geoData.position.lat, 10);

            this.state.hasSearched = true;

            AzureMaps.clearDataSources(this.state);

            if (this.state.searchType == 'events') {
                // mfe

                if (!this.state.useApi) {
                    this.filterEvents(sampleMfeEvents.data);
                    this.state.showSearchForm = false;
                    this.state.loading = false;
                } else {
                    axios.post(this.state.mfeapi, {
                        endpoint: '/v2/events?includeLocation=true',
                        method  : 'GET',
                        request : {
                            locatorPostalCode: this.state.searchPostalCode,
                            locatorCountry   : this.state.countryCode,
                            locatorRadius    : this.state.πsearchDistance,
                            locatorUnit      : this.state.distancePref,
                            page             : 0,
                            size             : 50,
                            sortOrder        : 'ASC'
                        }
                    }).then(res => {
                        this.filterEvents(JSON.parse(res.data.data));
                        this.state.showSearchForm = false;
                        this.state.loading = false;
                    });
                }

            } else {
                // locations & retailers

                if (!this.state.useApi) {
                    this.filterLocation(sampleData.data);
                    this.state.showSearchForm = false;
                    this.state.loading = false;
                } else {
                    let apiUrl = this.state.api.replace('{country}', this.state.countryCode);
                    apiUrl = apiUrl.replace('{unit}', this.state.distancePref);
                    apiUrl = apiUrl.replace('{postalCode}', this.state.searchPostalCode);
                    apiUrl = apiUrl.replace('{radius}', this.state.searchDistance);

                    axios.get(apiUrl).then(res => {
                        this.filterLocation(res.data.locations);
                        this.state.showSearchForm = false;
                        this.state.loading = false;
                    });
                }
            }
            
        },
        filterEvents (data) {
            data.forEach((event) => {
                const eventDetails = {
                    scheduledStart: event.scheduledStart,
                    scheduledEnd  : event.scheduledEnd,
                    shareLink     : event.shareLink,
                };

                const existingLocation = this.state.locations.filter(loc => {
                    return loc.id == event.shiptoId;
                });

                if (existingLocation.length) {
                    existingLocation[0].events.push(eventDetails);
                } else {
                    const newLocation = {
                        id                : event.shiptoId,
                        open              : false,
                        iconType          : 'MFE',
                        distanceAway      : AzureMaps.distanceAway(this.state, event.location.longitude, event.location.latitude),
                        events            : [eventDetails],
                        displayName       : event.eventName,
                        street            : event.location.address1,
                        city              : event.location.city,
                        state             : event.location.state,
                        countryCode       : event.location.country,
                        postalCode        : event.location.postalCode,
                        latitude          : event.latitude,
                        longitude         : event.longitude,
                        fittingTypes      : event.fittingTypes,
                        indoor            : event.indoor,
                        onsiteClubBuilding: event.onsiteClubBuilding
                    };

                    this.state.locations.push(newLocation);
                }

            });

            this.state.locations.sort(sortByDistanceAway);

            this.addLocationsToMap();
        },

        filterLocation (locations) {
            locations.forEach((loc) => {
                if (loc.onWebsite) {

                    loc.distanceAway = AzureMaps.distanceAway(this.state, loc.longitude, loc.latitude);

                    loc.iconType = 'RETAILER';
                    loc.open = false;

                    if (this.state.searchType == 'events' && loc.events && loc.events.length) {
                        loc.iconType = 'MFE';
                        this.state.locations.push(loc);
                    } 

                    if (this.state.searchType == 'locations' || this.state.searchType == 'retailers') {
                        loc.iconType = loc.selectFitLogoType.name;

                        if (loc.iconType == 'NFC') {
                            loc.iconType = 'PREM';
                        }

                        this.state.locations.push(loc);
                    }
                }
            });

            this.state.locations.sort(sortByDistanceAway);

            this.addLocationsToMap();
        },

        addLocationsToMap () {
            this.state.locations.forEach(item => {
                AzureMaps.addLocation(item); 
            });

            AzureMaps.setCameraToBounds();
        },

        async handleSearchArea () {
            AzureMaps.clearDataSources(this.state);

            const currentZoomLevel = Math.floor(window._AZURE_MAP.map.getCamera().zoom);
          
            this.state.searchDistance = 100;

            if (currentZoomLevel >= 9) {
                this.state.searchDistance = 50;
            }
            
            if (currentZoomLevel >= 11) {
                this.state.searchDistance = 25;
            }
 
            if (currentZoomLevel >= 13) {
                this.state.searchDistance = 10;
            }

            state.searchPostalCode = await AzureMaps.getLocationFromMapCenter();

            this.search();
        },

        // getBrowserCoordinates () {
        //     this.state.calculatingPostalCode = true;

        //     navigator.geolocation.getCurrentPosition(async (position) => {
        //         if (this.state.allowCalculatingPostalCode) {
        //             AzureMaps.setCameraPositionByLongLat(position.coords.longitude, position.coords.latitude);

        //             this.state.searchPostalCode = await AzureMaps.getLocationFromMapCenter();
        //         }
        //         this.state.calculatingPostalCode = false;
        //     }, function () {
        //         this.state.calculatingPostalCode = false;
        //     });
        // }
    },
};
</script>

<style scoped>
.sl-app {
    position: relative;
}
.sl-search-wrap {
    width: 100%;
}
.sl-map-wrapper {
    position: relative;
}
.sl-search-box {
    display: flex;
    flex-direction: column;
    background: #fff;

    z-index: 10;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 0px 3px rgba(0,0,0,0.2);
}

@media (min-width: 1000px) {
    .sl-search-box {
        border-radius: 15px;
        max-width: 390px;
        position: absolute;
        top: 25px;
        left: 25px;
        
    }
    .sl-search-box.show-results {
        bottom: 25px;
    }

}
@media (min-width: 1000px) {
    .sl-featured-location { 
        display: none; 
    }
}
.sl-list-wrapper {
    overflow-y: scroll;
}

.sl-popup {
    min-width: 200px;
    background: #fff;
}

.white-btn-search {
    z-index: 100;
    position: absolute;
    background: #fff;
    color: #000;
    appearance: none;
    border: none;
    border-radius: 24px;
    height: 40px;
    padding: 16px 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.10);
    left: 50%;
    transform: translateX(-50%);
    bottom: 350px;
    letter-spacing: 1px;

}
@media (max-width: 999px) { 
    .white-btn-search {
        display: none;
    }
    .white-btn-search.sl-visible {
        display: flex;
    }
}

@media (min-width: 1000px) {
    .white-btn-search {
        top: 25px;
        bottom: auto;
    }
}
.white-btn-search:hover {
    background: #f2f2f2;
}
</style>
